import React, { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import PreferencesForm from '../components/auth/PreferencesForm';
import { persistAuthSession, readStoredAuthSession, updateUserPreferences } from '../services/userService';
import './FoodDiaryPage.css';

const PreferencesPage = () => {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useOutletContext() ?? {};
  const { lang, t } = useLanguage();
  const p = t.preferences || {};

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [savedBanner, setSavedBanner] = useState(false);

  if (!currentUser) {
    navigate(lang === 'he' ? '/heb/login' : '/login', { replace: true });
    return null;
  }

  const userId = currentUser._id || currentUser.id;

  const handleSubmit = async (preferencesData, options = {}) => {
    const { silent = false } = options;

    if (!silent) {
      setIsSubmitting(true);
      setSavedBanner(false);
    }

    try {
      const response = await updateUserPreferences(userId, preferencesData);
      const updatedUser = response?.data ?? null;

      if (updatedUser) {
        setCurrentUser?.(updatedUser);
        const storedSession = readStoredAuthSession();
        if (storedSession?.session?.token) {
          persistAuthSession({
            data: updatedUser,
            session: storedSession.session,
          });
        }
      }

      if (!silent) {
        setSavedBanner(true);
        navigate(lang === 'he' ? '/heb' : '/');
      }
      return true;
    } catch (_err) {
      return false;
    } finally {
      if (!silent) {
        setIsSubmitting(false);
      }
    }
  };

  const handleSkip = () => {
    navigate(lang === 'he' ? '/heb' : '/');
  };

  return (
    <main className="preferences-page">
      <div className="preferences-page-inner">
        <div className="preferences-modal-shell" role="dialog" aria-modal="true" aria-label={p.pageTitle || 'Dietary Preferences'}>
          <div className="preferences-modal-title-row">
            <h1>{p.pageTitle || 'Dietary Preferences'}</h1>
          </div>
          {savedBanner && (
            <div className="preferences-saved-banner" role="status">
              {p.savedBanner || 'Preferences saved successfully.'}
            </div>
          )}
          <PreferencesForm
            initialValues={currentUser.preferences ?? {}}
            onSubmit={handleSubmit}
            onSkip={handleSkip}
            isSubmitting={isSubmitting}
            labels={p}
          />
        </div>
      </div>
    </main>
  );
};

export default PreferencesPage;
